/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-19 16:20:04
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-20 16:10:54
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/SearchInput/index.tsx
 */
import Search from 'src/components/Antd/Search/Search';
import React from 'react';
import css from './css.module.less';
import { SearchOutlined } from '@ant-design/icons';
import { getI18nFromGeneral } from '@/src/tools/tools';

const SearchInput = (props) => {
  const { onSearch, searchInputClassName, search, placeholder } = props;
  const [input, setInput] = React.useState(search || '');

  const handleOnPress = () => {
    if (onSearch) {
      onSearch(input);
    }
  };

  const handleOnSearch = () => {
    if (onSearch) {
      onSearch(input);
    }
  };
  return (
    <div className={css.container}>
      <Search
        maxLength={30}
        className={`${css.searchInput} ${searchInputClassName || ''}`}
        placeholder={
          placeholder || getI18nFromGeneral('general.filterGroup.search')
        }
        allowClear
        enterButton={getI18nFromGeneral('general.filterGroup.search')}
        prefix={<SearchOutlined />}
        onPressEnter={handleOnPress}
        onChange={(text, e) => {
          if (e.type === 'click') {
            setInput(text);
            if (!text) {
              onSearch(text);
            }
          } else {
            setInput(text);
          }
        }}
        value={input}
        onSearch={handleOnSearch}
      />
    </div>
  );
};
export default SearchInput;
